module.exports = __webpack_public_path__ + "img/Premium Clover 127.aded3d62.jpg";